import React, { useEffect, useState } from "react";
import NotFound from "../../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { toastMessage } from "../../../utils/toastMessage";
import { useSearchParams } from "react-router-dom";
import { Chathistory, getConsultantOrderHistoryApi } from "../../../services/consultantManagement";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Pagination from "react-js-pagination";
import { dateFormatWithTime } from "../../../utils/dateFormat";
import { IconButton, Paper, useScrollTrigger } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link, useParams } from "react-router-dom";
import AddNotification from "../../notificationManagement/AddNotification";
import ModalBox from "../../../components/modal/ModalBox";
import { FaPlay, FaPause } from 'react-icons/fa';


const ConsultantHistory = ({
  handlePageChange,
  total,
  activePage,
  orderList,
}) => {
  const [open, setOpen] = useState(false);
  const [openModalIndex, setOpenModalIndex] = useState(null);
  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  console.log('orderlistbegin------>', orderList)
  const [selectedUserName, setSelectedUserName] = useState("");


  const fetchRoomChats = async (orderId, orderList) => {
    console.log('orderlist------>', JSON.stringify(orderList));
    setIsLoading(true);
    try {
      // Find the order with the matching orderId
      const order = orderList.find(order => order._id === orderId);

      if (order) {
        // Extract roomId from the first chat in the chats array
        const chatId = order?.chats?.[0]?._id;  // Access first chat's _id

        if (!chatId) {
          console.log('Chat ID not found!');
          return;
        }

        // Prepare sendData with chatId
        const sendData = {
          chatId: chatId,  // Pass the chat ID here
        };

        console.log("Sending data to Chathistory:", sendData);

        // Make API call with sendData
        const { data, status } = await Chathistory(sendData);  // Destructure data from response

        console.log('chatsss------>', JSON.stringify(data));

        // Check if the response contains chat data
        if (data && data.result) {
          setChatMessages(data.result.chats);  // Update chat state
        }
        const messages = data.result.chats.map((chat, index) => {
          return chat.message;
        });
        console.log('Messages:', messages);
      } else {
        console.log('Order not found!');
      }
    } catch (error) {
      console.error('Error fetching chats:', error);
    } finally {
      setIsLoading(false);
      setOpen(true);
    }
  };





  return (
    <>
      <ModalBox
        status={open}
        onClose={() => setOpen(false)}
        title={selectedUserName}
        customizedFooter
        size={"sm"}
        closeIcon
        custom
      >
        <div className="chat-container">
          {chatMessages.length > 0 ? (
            chatMessages.map((message, index) => {
              // Ensure timestamp is valid
              const timestamp = new Date(message.createdAt).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
                day: "numeric",
                month: "numeric",
                year: "2-digit",
              });

              return (
                <>
                  {/* <div
                  key={index}
                  style={{ border: '2px solid #000', padding: '10px 10px 10px 10px',borderRadius:'10px',marginTop:'10px' }}
                  className={`message-${message.isMessageByUser ? 'user' : 'consultant'}`}
                >
                 
                  {message?.messageType === 1 && <p className="text">{message.message || ''}</p>}

                
                  <span className="timestamp" style={{alignSelf:'center'}}>{timestamp} </span>
                </div> */}
                  <div
                    key={index}
                    style={{ border: '2px solid #000', padding: '10px 10px 10px 10px', borderRadius: '10px', marginTop: '10px' }}
                    className={`message-${message.isMessageByUser ? 'consultant' : 'user'}`}>
                    {message?.messageType === 1 ? (
                      <p>{message.message || ''}</p>
                    ) : message?.messageType === 5 ? (
                      message.file?.[0]?.mediaType === 'image' ? (
                        <img src={message.file[0].mediaUrl} alt="Media" className="message-image" />
                      ) : message.file?.[0]?.mediaType === 'audio' ? (
                        <AudioPlayer source={message.file[0].mediaUrl} />
                      ) : null
                    ) : null}
                    <span className="timestamp" style={{ alignSelf: 'center' }}>{timestamp} </span>
                  </div>
                </>
              );
            })
          ) : (
            <p>No chat history found.</p>
          )
          }


        </div>
      </ModalBox>

      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>User Id</th>
              <th>User Name</th>
              <th>Consultant Name</th>
              <th>Date and Time</th>
              <th>Consultant Type</th>
              <th>Chat History</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {orderList.length > 0 ? (
              orderList.map((order, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{order?.userDetail?.userId || "---"}</td>
                  <td>{`${order?.firstName} ${order?.lastName}`}</td>
                  <td>{order?.consultantDetail?.name || "---"}</td>
                  {/* <td>{order?.createdAt || "---"}</td> */}
                    <td>{dateFormatWithTime(order?.createdAt) || '---'}</td>
                  <td>{order?.typeOfConsult || "---"}</td>
                  <td>
                    {order?.typeOfConsult === "chat" &&
                      order?.isConsultantCompleted === "complete" &&
                      order?.typeOfConsult !== "audio" &&
                      order?.typeOfConsult !== "video" ? (
                      <IconButton
                        aria-label="update"
                        className="px-2 py-0"
                      >
                        <VisibilityIcon
                          className="eye_icon"
                          onClick={() => {
                            setOpen(true);
                            fetchRoomChats(order._id, orderList);
                            setSelectedUserName(`${order?.firstName} ${order?.lastName}`);
                          }}
                        />
                      </IconButton>
                    ) : (
                      "-----"
                    )}
                  </td>


                  <td>{order?.totalAmountPayToConsultant || "---"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No Order Found!</td>
              </tr>
            )}
          </tbody>
        </table>
        {total > 1 ? (
          <div className="pagination-wrapper">
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
export default ConsultantHistory;


const AudioPlayer = ({ source }) => {
  const [audio, setAudio] = useState(new Audio(source));
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [audio]);

  const handleAudio = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="audio-container">
      <button onClick={handleAudio} className="audio-button">
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>
      <span className="audio-label">Recording</span>
    </div>
  );
};
